(ns pfo.mcp.core
  "Route handler for the MCP connections settings page (wraps the list in the admin tabs)."
  (:require [pfo.admin.component :as admin-component]
            [pfo.flash :refer [set-flash]]
            [pfo.mcp.component :as component]
            [pfo.util :as util]))

(defn connections-page [params]
  ;; Flash the result of a shared-connection OAuth flow (the callback redirects here with ?mcp_oauth=).
  (case (:mcp_oauth (:query-params params))
    "ok"  (set-flash :success "Connection authorized.")
    nil   nil
    (set-flash :error "Authorization failed. Please try again."))
  (util/set-page
   (#'admin-component/ai-tabs nil
                              component/integrations
                              :integrations)))

(defn connected-apps-page
  "User-facing page to authorize external (OAuth, per-user) apps granted to the user's families.
   Rendered inside the settings tab bar so the menu stays and the Apps tab highlights."
  [params]
  (util/set-page
   (#'admin-component/admin-tabs nil
                                 (partial component/connected-apps params)
                                 :apps)))
